import React from 'react';
import COLORS from '../theme/themes/default';

const LayoutContext = React.createContext({
  backgroundColor: COLORS.light.primary,
  text: {
    fontSize: 16,
    fontColor: undefined
  }
});

export default LayoutContext;
